import React from "react";

// How to bump, Wii-manual style: two forearms from the side, each fist gripping a phone, meet knuckle to
// knuckle with an impact flash, pull back, repeat. Pure SVG + CSS, so it's crisp at any size.
const LOOP = '1.8s';

const SLEEVE = {left: '#3b6fd8', right: '#d8473b'};

const Arm = ({side}) => (
    // drawn as the left arm, coming in nearly level from the side; the right one is mirrored
    <g transform={side === 'right' ? 'translate(320,0) scale(-1,1)' : undefined}>
        <g className={`bump-move-${side}`}>
            <g transform="rotate(-8 40 150)">
                {/* sleeve: most of the arm is shirt, so it reads as a person's arm; long enough to stay past the edge */}
                <rect x="-200" y="80" width="258" height="40" rx="10" fill={SLEEVE[side]} stroke="#1c2233" strokeWidth="2.5" />
                <rect x="50" y="78" width="14" height="44" rx="5" fill={SLEEVE[side]} stroke="#1c2233" strokeWidth="2.5" />
                {/* wrist */}
                <rect x="62" y="88" width="18" height="26" rx="6" fill="#e8dfd1" stroke="#8a8072" strokeWidth="2.5" />
                {/* phone in the grip, upright */}
                <rect x="90" y="40" width="28" height="56" rx="6" fill="#2a2d35" stroke="#a7adb8" strokeWidth="2.5" />
                <rect x="94" y="46" width="20" height="24" rx="3" fill="#ff8a4c" />
                {/* fist with knuckles facing the other one */}
                <path d="M76 82 h40 q14 0 14 12 v20 q0 12 -14 12 h-40 q-6 0 -6 -6 v-32 q0 -6 6 -6 z"
                      fill="#ece5d9" stroke="#8a8072" strokeWidth="2.5" />
                <path d="M122 86 q8 2 8 8 M122 98 q8 2 8 8 M122 110 q7 2 7 7" fill="none" stroke="#8a8072" strokeWidth="2.5" strokeLinecap="round" />
                <path d="M84 88 q12 -6 24 0" fill="none" stroke="#8a8072" strokeWidth="2.5" strokeLinecap="round" />
            </g>
        </g>
    </g>
);

export const BumpDemo = () => (
    // full-bleed: the arms come in from the screen's edges, not the page padding's
    <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 6, margin: '0 -18px'}}>
        <style>{`
            .bump-move-left, .bump-move-right { animation: bump-in ${LOOP} ease-in-out infinite; }
            @keyframes bump-in {
                0%, 15% { transform: translateX(0px); }
                42% { transform: translateX(39px); }
                47% { transform: translateX(34px); }
                70%, 100% { transform: translateX(0px); }
            }
            .bump-flash { animation: bump-flash ${LOOP} linear infinite; transform-origin: 160px 92px; }
            @keyframes bump-flash {
                0%, 40% { opacity: 0; transform: scale(0.6); }
                43% { opacity: 1; transform: scale(1); }
                58% { opacity: 0; transform: scale(1.35); }
                100% { opacity: 0; }
            }
        `}</style>
        <svg viewBox="0 0 320 150" style={{width: '100%', display: 'block'}}>
            <Arm side="left" />
            <Arm side="right" />
            <g className="bump-flash" stroke="#ffd24a" strokeWidth="4" strokeLinecap="round">
                <line x1="160" y1="58" x2="160" y2="40" />
                <line x1="160" y1="126" x2="160" y2="144" />
                <line x1="180" y1="70" x2="194" y2="58" />
                <line x1="140" y1="70" x2="126" y2="58" />
                <line x1="180" y1="114" x2="194" y2="126" />
                <line x1="140" y1="114" x2="126" y2="126" />
            </g>
        </svg>
        <div style={{fontSize: 18, fontWeight: 700, opacity: 0.8}}>Phone in your fist. Knuckles meet.</div>
    </div>
);
